


















import Vue from 'vue'
import ApplicationHeader from './ApplicationHeader.vue'
import SideNavigation from './SideNavigation.vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import {
  COMMON_ROUTES,
  getAdminNavigations,
  getCareTeamNavigations,
  getExecNavigations,
  getNursingHomeNavigations,
  getRocheConsultantNavigations,
  NURSING_HOME_ROUTES,
  SideNavigationType,
} from '@/layouts/navigations'
import { USER_ROLE_TYPES } from '@/store/modules/app/types'
import { AppGetterNames } from '@/store/modules/app/keys'
import { INCLUDE_DASHBOARDS, INCLUDE_MAP, NURSING_HOME_MENU } from '@/constants/app-variables'
import ApplicationFooter from '@/layouts/ApplicationFooter.vue'

export default Vue.extend({
  components: {
    SideNavigation,
    ApplicationHeader,
  },
  data() {
    return {
      role: USER_ROLE_TYPES.CARE_TEAM,
      // openingMenuName: getOpeningMenuName(),
      sideNavClass: INCLUDE_MAP ? 'd-xl-flex' : 'd-md-flex', // map takes up a lot more width.
    }
  },
  computed: {
    ...mapGetters(ModuleNames.siteStats, {
      siteStatses: SiteStatsGetterNames.siteStatses,
    }),
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isRocheConsultant: AppGetterNames.isRocheConsultant,
      isExecUser: AppGetterNames.isExecUser,
    }),
    currentNavigations(): SideNavigationType[] {
      if (this.isAdminUser) {
        return getAdminNavigations(this.siteStatses)
      }
      if (this.isRocheConsultant) {
        return getRocheConsultantNavigations(this.siteStats)
      }
      if (NURSING_HOME_MENU) {
        return getNursingHomeNavigations(this.siteStatses, this.isAdminUser)
      }
      if (this.isExecUser) {
        return getExecNavigations(this.siteStatses)
      }

      return getCareTeamNavigations()
    },
    openingMenuName() {
      if (this.isRocheConsultant) {
        return COMMON_ROUTES.SITE_STATS.name
      }
      if (NURSING_HOME_MENU) {
        return NURSING_HOME_ROUTES.PATIENTS.name
      } else {
        return COMMON_ROUTES.REPORTS.name
      }
    },
  },
  async mounted(): Promise<void> {
    if (this.isAdminUser || this.isExecUser) {
      await this[SiteStatsActionNames.getSiteStatses]()
    }
  },
  methods: {
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
  },
})
